module.exports = __webpack_public_path__ + "img/unnamed2.35dd6f21.png";